<template>
    <Form @submit="submit">
        <span style="color:red;margin:5px">*</span>&nbsp;<span>头像</span>
        <UploadImage
                style="margin:5px 90px"
                :imageList="image"
                type="SystemImage"
                :count="1"
                @imageChange="imageChange"
                edit
        />
        <Field
                label="昵称"
                required
                v-model="user.realName"
                :rules="[
                {  required: true, message: '请输入昵称' },
                {  validator  : validatorName, message: '昵称长度为4-20' },
                ]"
        />
        <Field
                label="用户名"
                disabled
                v-model="user.username"
        />
        <Field
                label="手机号码"
                required
                v-model="user.tel"
                :rules="[
                {  required: true, message: '请输入手机号码' },
                {  pattern : /^.{11}$/, message: '手机号码为11位' },
                {  validator  : validatorPhone, message: '该手机号已绑定' },
                ]"
        />
        <Field
                label="邮箱"
                v-model="user.email"
                :rules="[
                { validator:patternEmail ,message:'邮箱格式不正确'},
                { validator:validatorEmail,message:'该邮箱已存在'},
                ]"
        />
        <Field
                label="角色"
                disabled
                v-model="user.roleName"
        />
        <Field
                label="所属项目"
                disabled
                v-model="user.unitName"
        />
        <Field
                label="激活状态"
                disabled
                v-model="dataStateDICT"
        />
        <Field
                label="密码时效"
                disabled
                v-model="pwdExpriredTimeType"
        />
        <Field label="APP推送">
            <ASwitch slot="input" v-model="user.pushApp" size="24"/>
        </Field>
        <Field label="短信推送">
            <ASwitch slot="input" v-model="user.pushSms" size="24"/>
        </Field>
        <Field label="语音推送">
            <ASwitch slot="input" v-model="user.pushTel" size="24"/>
        </Field>
        <Field label="网页推送">
            <ASwitch slot="input" v-model="user.pushWeb" size="24"/>
        </Field>
        <Field label="微信推送">
            <ASwitch slot="input" v-model="user.pushWechat" size="24"/>
        </Field>
        <Button type="info" block style="width: 95% ; margin: 10px auto;" native-type="submit">确认修改</Button>
    </Form>
</template>

<script>
    import {Button, Cell, Field, Form, Switch} from "vant"
    import {mapGetters} from 'vuex'
    import UploadImage from "@/components/UploadImage";
    import {getStrLength,} from '@/utils/tool'

    export default {
        components: {Field, UploadImage, ASwitch: Switch, Cell, Button, Form},
        props: {},
        data() {
            return {
                user: {},
            }
        },
        computed: {
            image() {
                return this.user.avatar ? [this.user.avatar] : []
            },
            dataStateDICT() {
                return this.user.dataState == "Enable" ? "启用" : "禁用";
            },
            pwdExpriredTimeType() {
                return this.user.pwdExpriredTimeType == 0 ? "永久" : "180天后过期";
            },
            ...mapGetters({userInfo: 'global/userInfo'})
            // ...mapGetters({user: 'global/userInfo'})
        },
        created() {
        },
        mounted() {
            this.user = this.userInfo;
        },
        methods: {
            patternEmail(value) {
                const length = getStrLength(value);
                if (length == 0) {
                    return true;
                }
                return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value);
            },
            imageChange(imageList) {
                this.user.avatar = imageList[0];
            },
            validatorName(value) {
                const length = getStrLength(value);
                return length >= 4 && length <= 20
            },
            validatorPhone(value) {
                const oldTel = this.user.tel;
                if (oldTel == value) {
                    return true;
                }
                return new Promise(resolve => {
                    this.$http.tokiot.sys.user.existMobile({mobile: value})
                        .then(ret => resolve(ret))
                })
            },
            validatorEmail(value) {
                const oldEmail = this.user.email;
                if (oldEmail == value) {
                    return true;
                }
                return new Promise(resolve => {
                    this.$http.tokiot.sys.user.existEmail({email: value})
                        .then(ret => resolve(ret))
                })
            },
            submit() {
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.sys.user.update(this.user)
                    .then(res => {
                        this.$toast.clear();
                        if (res) {
                            this.$toast.success("修改成功")
                            setTimeout(() => {
                                this.$router.history.go(-1);
                            }, 500);
                        } else {
                            this.$toast.fail(res.message)
                        }
                    })
            }
        },
        watch: {
            userInfo(userInfo) {
                this.user = userInfo
            }
        }
    }
</script>

<style scoped>

</style>